import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AlertService, ApiService } from '../_services';
import { Whitelabel } from '../_models/whitelabel.model';
import { MemberService } from '../_services/member.service';
import * as _ from 'lodash';
import { WhitelabelService } from '../_services/whitelabel.service';
import { AppComponent } from '../app.component';
import { JwtHelper } from '../_services/jwt-helper';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.scss']
})
export class LoginComponent implements OnInit {

    @ViewChild('notificationBlockLogin') notificationBlockLogin : ElementRef;

    emailText:string = ""
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    whitelabels: Whitelabel[];
    prescriptioncard: any;
    currentProductId: number;
    AppComponent = AppComponent;
    homeContentHtml = "";
    constructor(
        private whitelabelService: WhitelabelService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private apiService: ApiService,
        public memberService: MemberService,
        private alertService: AlertService) {}

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
        var _this = this;
        this.f.username.valueChanges.subscribe(r=>{
            if((/\s/g).test(r)){
                _this.f.username.setValue(r.replace(/\s/g,''))
            }          
        })

        // reset login status
        this.memberService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

        this.getWhitelabelConfig();
        this.getWhitelabelByUrl();

        var temp = $('#homeContentDiv').load(AppComponent.siteBranding.homeContent, function(){
            //$('#homeContentDiv')
            _this.homeContentHtml =temp[0].innerHTML;
        })

        if (this.memberService.currentMember != null && !this.memberService.currentMember.active) {
            $(this.notificationBlockLogin.nativeElement).show(1000)
        }
    }

    getWhitelabelConfig(){
        
         this.prescriptioncard = JSON.parse(this.whitelabelService.getSettingByFeatureName('prescriptioncard'));
        // console.log(this.prescriptioncard);
    }

    async getWhitelabelByUrl(){
        var w =  AppComponent.whitelabel
        this.currentProductId = w.productId;
    }
    // onChangeEmail(){
    //     console.log(1)
    // }
    onPasteEmail($e: any){
        // $e.preventDefault();
        // return false
        // var tempText = $e.clipboardData.getData('text');
        // console.log(tempText.trim().length)
        // console.log(this.emailText)
        // this.emailText = tempText.trim();
        // this.f.username.setValue('');
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;

        if(this.isSubdomain("member.mylifewellness.net")){
            this.alertService.error("Please check that your email and password is correct");
            this.loading = false;
            return;
        }
        

        this.apiService.login(this.f.username.value, this.f.password.value, this.currentProductId)
            .subscribe(
                data => {
                    let jwtHelper = new JwtHelper();
                    var openIdTokenParams = data;
                    let decodedToken = jwtHelper.decodeToken(openIdTokenParams.id_token);
                    
                    if(window.location.href.indexOf(decodedToken.website) < 0){
                        window.location.href = "https://" + decodedToken.website + '/login-with-token?memberId=' + decodedToken.sub + '&code=' + openIdTokenParams.id_token + '&productId=' + decodedToken.productId;
                    }
                    else{
                        localStorage.setItem('openIdTokenParams', JSON.stringify(data));
                        this.router.navigate([this.returnUrl]);
                        this.memberService.isLoggedin = true;
                    }
                   
                },
                error => {
                    console.log(error);
                    this.alertService.error(error.error_description);
                    this.loading = false;
                });
    }

    isSubdomain(subDomain){
        return window.location.href.indexOf('member.mylifewellness.net') > -1 ||
         window.location.href.indexOf(subDomain) > -1 || window.location.href.indexOf('membersandbox.chordial.com') > -1;
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts